import { Component, OnInit, ElementRef, ChangeDetectorRef,Inject, Renderer2  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, fromEvent } from 'rxjs';
import { LoginComponent } from 'projects/hp-api/src/lib/login/login.component';
import { InfosComponent } from 'projects/hp-api/src/lib/dialogs/infos/infos.component';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { AuthentificationService } from "projects/hp-api/src/lib/services/authentification-service.service";
import { UserService } from "projects/hp-api/src/lib/services/user.service";
import { DevisFormComponent } from 'projects/hp-api/src/lib/devis-form/devis-form.component';
import { User, Client } from 'projects/hp-api/src/lib/models/user';
import { Location, DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AlertService } from 'projects/hp-api/src/lib/services/alert.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends WizardHpBaseComponent implements OnInit {
  paramterUuid: string;
  paramterOrigin: string;
  couleur_1 = "#C0B800";
  couleur_2: "#56565A";
  currentUser: User;
  currentUserSubscription: Subscription;
  users: User[] = [];
  clients: Client[] = [];
  user_email: any;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  etape_show = false;
  title_etap_1 = "Votre maison";
  title_etap_2 = "Votre porte";
  panelOpenState = false;
  path = "riou-glass";
  private native: any;
  private gammes: any;
  popMessage = true;
  isMobile = false;

  constructor( @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2, chgDetectorRef: ChangeDetectorRef,
     hpService: HpService,
     private authentificationService: AuthentificationService,
    private userService: UserService, 
    private alertService: AlertService,
    private route: ActivatedRoute, router: Router, location: Location, public dialog: MatDialog,
    private elRef: ElementRef) {

      super(chgDetectorRef, hpService, router);

    this.path = window.location.pathname.replace(/^\/+/, '');
    this.native = elRef.nativeElement;

    this.couleur_1 = this.getHpService().getConfig().default_couleur;
    this.couleur_2 = this.getHpService().getConfig().active_couleur;

  }

  ngOnInit() {
    super.ngOnInit();
    var me = this;

    me.onResize(window.innerHeight, window.innerWidth);
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      me.onResize(window.innerHeight, window.innerWidth);
    });
    setTimeout(() => {
      this.etape_show = true;
    }, 100);
  }

  onResize(windowInnerHeight : any, windowInnerWidth : any) {
    
    this.title_etap_1 = windowInnerWidth > 640 ? "Votre maison" : "Maison";
    this.title_etap_2 = windowInnerWidth > 640 ? "Votre porte" : "Porte";

    this.renderer.removeClass(this.document.body, 'is_width_dkpt_mini');
    this.renderer.removeClass(this.document.body, 'is_tablet');
    this.renderer.removeClass(this.document.body, 'is_phone');
    this.renderer.removeClass(this.document.body, 'is_desktop');
    this.renderer.removeClass(this.document.body, 'is_portrait');
    this.renderer.removeClass(this.document.body, 'is_landscape');

    this.getHpService().initBrowserSpecifics(windowInnerHeight, windowInnerWidth);

    if (this.getHpService().getIsLandscape()) {
      this.renderer.addClass(this.document.body, 'is_landscape');
    } else {
      this.renderer.addClass(this.document.body, 'is_portrait');
    }

    if (this.getHpService().getIsMobile()) {
      this.renderer.addClass(this.document.body, 'is_phone');
      this.isMobile = true;
    } else if (this.getHpService().getIsTablet()) {
      this.renderer.addClass(this.document.body, 'is_tablet');
    } else if (this.getHpService().getIsDesktop())  {
      this.renderer.addClass(this.document.body, 'is_desktop');
      if (this.getHpService().getIsDkptMinWidth()) {
        this.renderer.addClass(this.document.body, 'is_width_dkpt_mini');
      }
    }
  }

  ngAfterViewChecked() {

  }
  logout() {
    this.authentificationService.logout();

  }

  getUser() {
    return this.authentificationService.currentUserValue;
  }

  displayHeader(): Boolean {

    return;

  }
  getStatutMatButton() {

    return this.getHpService().getStatutMatButton();
  }
  getMenu() {
    return null;
    //return this.portesService.getMenu();
  }

  public getHeaderIn() {
    return null;
    //return this.portesService.getHeaderIn();
  }


  openDialogLogin(demande: string) {
    const dialogRef = this.dialog.open(LoginComponent, {
      panelClass: 'full-width-dialog-login',
      data: { name: demande }
    });


    dialogRef.afterClosed().subscribe(result => {

    });

  }

  openDialogSign(demande: string) {


    const dialogRef = this.dialog.open(DevisFormComponent, {
      panelClass: 'full-width-dialog-devis',
      data: { name: demande }
    });


    dialogRef.afterClosed().subscribe(result => {

    });

  }

  openDialogInfo(demande: string) {


    const dialogRef = this.dialog.open(InfosComponent, {
      panelClass: 'full-width-dialog-info',
      data: { name: demande }
    });


    dialogRef.afterClosed().subscribe(result => {

    });

  }

  getCurrentPage() {
    return null;
    //return this.portesService.getCurrentPage();
  }

  initMap() {
    let dataMap = {
      "visible": 0,
      "linkposition": "46.98123233164222,1.805750207787383",
      "heading": 108.76767031965346,
      "pitch": 2.8858925347222737,
      "fov": 159
    };
    //this.portesService.setDataMap(dataMap);
  }

  public filterProduit(produit, slug) {
    return Object.values(produit).filter(object => {
      return object['profile'].slug === slug;
    });
  }

  public getConfig() {
    return this.getHpService().getConfig();
  }

  public getSlug() {
    return this.getHpService().getSlug();
  }
  closeMesg()
  {
    this.popMessage = false;
   
  }
}
